import React from "react";

const Mobile = (props) => {

	const prop = props;

	return (
		<>
			<button
				type="button"
				className="tab-button"
				onClick={() => prop.handleChangeTabs(prop.type)}
			>
				{prop.name}
			</button>
			<style jsx>
				{`
					.tab-button {
						padding: 6px 16px;
						border: 1px solid ${prop.tabChoose === prop.type ? "#DB284E" : "#DFE3E8"};
						border-radius: 16px; 
						color: ${prop.tabChoose === prop.type ? "#DB284E" : "#000000"};
						background-color: #ffffff;
						cursor: pointer;
					}
				`}
			</style>
		</>
	);

};

export default Mobile;
